// services/GetPensionFundManagerService.ts
import {
  ApiResponse,
  pfmlist,
} from "@/utils/types/NPS/Stepper/PensionFundManager";
import { get } from "@/services/axiosUitils";

// This will be proxied to Protean during development
const baseUrl = "nps/cra/pfms/";

class GetPensionFundManagerService {
  getPensionFundManager = async (): Promise<pfmlist> => {
    const response = await get<pfmlist>(baseUrl);
    return response;
  };

  getSchemeByPfmId = async (id: string): Promise<ApiResponse> => {
    const response = await get<ApiResponse>(`${baseUrl}${id}/schemes/`);
    return response;
  };
}

const instance = new GetPensionFundManagerService();
export default instance;
